<script lang="ts">
	import { format } from 'svelte-i18n';
	// Stores
	import type { FilterOption } from 'src/stores/ui/filters';

	// Design system components
	import { Token } from '@Shelly/shelly-design-system';

	export let appliedFilters;
	export let toggleFilterOptions;

	let filterOptions: FilterOption[] = [
		{
			id: 'online',
			title: $format('filter_online', {
				default: 'Online',
			}),
			translationDefault: 'Online',
			selected: false,
		},
		{
			id: 'offline',
			title: $format('filter_offline', {
				default: 'Offline',
			}),
			translationDefault: 'Offline',
			selected: false,
		},
	].map((option) => {
		const storeOption = appliedFilters.device_state.find((filter) => filter.id === option.id);
		option.selected = storeOption.selected;
		return option;
	});

	const handleSelectFilter = (option) => {
		appliedFilters.device_state = appliedFilters?.device_state.map((filter) => {
			if (filter.id === option.id) {
				filter.selected = !filter.selected;
				return filter;
			}
			return filter;
		});

		filterOptions = toggleFilterOptions(filterOptions, option);
	};

	const resetData = () => {
		appliedFilters.device_state = appliedFilters.device_state.map((filter) => {
			if (filter.selected) {
				filter.selected = !filter.selected;
			}
			return filter;
		});

		filterOptions = filterOptions.map((filter) => {
			return {
				...filter,
				selected: false,
			};
		});
	};
</script>

<svelte:window on:reset={resetData} />

<div class="d-flex flex-wrap" style="gap: 8px;">
	{#each filterOptions as option}
		<Token
			id="token-rfx6jp1"
			size="m"
			title={option.title}
			on:click={() => handleSelectFilter(option)}
			selected={option.selected}
		/>
	{/each}
</div>
